// import React from 'react';

// const steps = [
//   { step: '01', title: 'Initial Consultation', desc: 'Understand your needs and aspirations.' },
//   { step: '02', title: 'Personalized Guidance', desc: 'Get tailored advice and direction.' },
//   { step: '03', title: 'Execution & Support', desc: 'Stay supported throughout your journey.' },
// ];

// const ProcessSteps = () => (
//   <section id="process" className="bg-gradient-to-br from-blue-50 to-blue-100 py-16">
//     <div className="text-center mb-10">
//       <h2 className="text-3xl font-bold text-blue-800">Our Simple Process to Success</h2>
//       <p className="text-gray-600 mt-2">Navigate through structured steps to build your career</p>
//     </div>
//     <div className="flex flex-wrap justify-center gap-8 px-6">
//       {steps.map(({ step, title, desc }) => (
//         <div key={step} className="w-full md:w-1/4 bg-white rounded p-6 shadow-md">
//           <h3 className="text-blue-600 text-xl font-bold">{step}</h3>
//           <p className="text-lg font-semibold mt-2">{title}</p>
//           <p className="text-gray-600 mt-1">{desc}</p>
//         </div>
//       ))}
//     </div>
//   </section>
// );

// export default ProcessSteps;
import React from "react";
import { FaComments, FaLightbulb, FaRocket } from "react-icons/fa";
import StarsBackground from "../backgrounds/StarsBackground";

const steps = [
  { 
    step: "01", 
    title: "8th Standard — Awareness", 
    desc: "Foundation stage — explore interests, strengths, and potential career paths. Focus on skill-building, exposure, and curiosity.", 
    icon: <FaComments className="text-4xl text-blue-500 group-hover:scale-125 transition-transform" /> 
  },
  { 
    step: "02", 
    title: "10th Standard — Stream Selection", 
    desc: "Critical decision-making stage. Guidance on Science, Commerce, Arts based on aptitude and goals.", 
    icon: <FaLightbulb className="text-4xl text-yellow-500 group-hover:scale-125 transition-transform" /> 
  },
  { 
    step: "03", 
    title: "12th Standard — Career Selection", 
    desc: "Choosing the right career path: Engineering, Medicine, Chartered Accountancy, or other professional fields.", 
    icon: <FaRocket className="text-4xl text-pink-500 group-hover:scale-125 transition-transform" /> 
  },
  { 
    step: "04", 
    title: "Post 12th — Higher Education", 
    desc: "Detailed planning for higher education, entrance exams, college selection, and graduation planning.", 
    icon: <FaComments className="text-4xl text-green-500 group-hover:scale-125 transition-transform" /> 
  },
  { 
    step: "05", 
    title: "Career Growth & Switch", 
    desc: "Guidance on job satisfaction, career growth, when to switch jobs, and higher studies vs job decisions.", 
    icon: <FaLightbulb className="text-4xl text-purple-500 group-hover:scale-125 transition-transform" /> 
  },
];

const ProcessSteps = () => (
  <section id="process" className="relative bg-gradient-to-br from-blue-50 via-purple-50 to-pink-100 py-20 overflow-hidden">
    {/* Subtle animated blobs in background */}
    <StarsBackground />
    <div className="absolute -top-10 left-0 w-48 h-48 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
    <div className="absolute bottom-0 right-10 w-64 h-64 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-bounce"></div>

    <div className="relative text-center mb-12">
      <h2 className="text-4xl md:text-5xl font-extrabold text-gray-800 drop-shadow">
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500">Career Stages</span> — Your Journey
      </h2>
      <p className="text-gray-600 mt-3 max-w-xl mx-auto">
        Structured guidance at every key decision point in your career 🚀
      </p>
      <p className="text-gray-500 mt-1 max-w-lg mx-auto text-sm italic">
        Don't leave your career to chance — invest time, build career, secure future.
      </p>
    </div>

    <div className="relative flex flex-wrap justify-center gap-10 px-6">
      {steps.map(({ step, title, desc, icon }) => (
        <div 
          key={step} 
          className="group relative w-full sm:w-[280px] p-8 rounded-2xl shadow-xl bg-white/70 backdrop-blur-md border border-white hover:scale-105 hover:shadow-2xl transition-all duration-300"
        >
          {/* Step Number Circle */}
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 flex items-center justify-center text-white font-bold shadow-lg">
            {step}
          </div>
          <div className="flex justify-center mb-4">{icon}</div>
          <h3 className="text-lg font-bold text-gray-800">{title}</h3>
          <p className="text-gray-600 text-sm mt-2">{desc}</p>
        </div>
      ))}
    </div>

    {/* Conversion Funnel */}
    <div className="relative max-w-4xl mx-auto mt-20 px-6">
      <h3 className="text-2xl md:text-3xl font-bold text-center mb-8 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
        Your Journey With Us
      </h3>
      <div className="flex flex-col md:flex-row items-center justify-center gap-4">
        {[
          { step: "1", label: "Website Visit", icon: "🌐" },
          { step: "2", label: "Free Webinar / Seminar Signup", icon: "📋" },
          { step: "3", label: "WhatsApp Follow-up", icon: "💬" },
          { step: "4", label: "One-on-One Paid Consultation", icon: "🤝" },
          { step: "5", label: "Long-Term Mentorship Program", icon: "🎯" },
        ].map((item, i) => (
          <React.Fragment key={item.step}>
            <div className="flex flex-col items-center bg-white/80 backdrop-blur-md rounded-xl px-5 py-4 shadow-md min-w-[140px] text-center">
              <span className="text-2xl mb-1">{item.icon}</span>
              <span className="text-xs font-bold text-purple-600">Step {item.step}</span>
              <span className="text-sm font-medium text-gray-700 mt-1">{item.label}</span>
            </div>
            {i < 4 && <span className="text-2xl text-purple-400 hidden md:block">→</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  </section>
);

export default ProcessSteps;
